var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "ai-assistant-prompts" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.prompts.length > 0,
            expression: "prompts.length > 0",
          },
        ],
        staticClass: "ai-assistant-prompts",
      },
      [
        _c(
          "a-space",
          { staticStyle: { "flex-wrap": "wrap" } },
          _vm._l(_vm.prompts, function (pItem, pIndex) {
            return _c(
              "div",
              {
                key: `${_vm.index}-${pIndex}`,
                staticClass: "ai-assistant-prompts-card",
                on: {
                  click: function ($event) {
                    return _vm.onClick(pItem)
                  },
                },
              },
              [
                _c("TextTooltip", {
                  staticClass: "ai-assistant-prompts__title",
                  attrs: { text: pItem.title },
                }),
                _c("div", { staticClass: "ai-assistant-prompts__desc" }, [
                  _vm._v(_vm._s(pItem.content)),
                ]),
              ],
              1
            )
          }),
          0
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }